import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

export const CreateExpenseCard = ({ onClick }) => {
    const theme = useTheme();

    return (
        <Card 
            sx={{ 
                minWidth: 275, 
                marginBottom: 2, 
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
            }}
        >
            <CardActionArea onClick={onClick}>
                <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <AddCircleOutlineIcon sx={{ marginRight: 1, fontSize: 'large', color: theme.palette.primary.main }} />
                        <Typography variant="h6" component="div">
                            Add New Expense
                        </Typography>
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
